export var defaultInvalidDate = 'Invalid date';

export function invalidDate() {
    return this._invalidDate;
}



//////////////////
// WEBPACK FOOTER
// D:/Projects/MDA/schoolofmusic-ucla/web/app/themes/ucla/node_modules/moment/src/lib/locale/invalid.js
// module id = 67
// module chunks = 0